import { render } from "./DragCard4.vue?vue&type=template&id=6d2adf99&scoped=true&ts=true"
import script from "./DragCard4.vue?vue&type=script&lang=ts"
export * from "./DragCard4.vue?vue&type=script&lang=ts"

import "./DragCard4.vue?vue&type=style&index=0&id=6d2adf99&lang=scss&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d2adf99"]])

export default __exports__